import React from 'react';

/**
 * ErrorBoundary — Global error boundary component.
 * Catches JavaScript errors anywhere in child component tree
 * and displays a fallback UI instead of crashing the entire app.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ errorInfo });
        // Log error to monitoring service if available
        if (import.meta.env.DEV) {
            console.error('ErrorBoundary caught:', error, errorInfo);
        }
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
    };

    render() {
        if (this.state.hasError) {
            // Custom fallback UI if provided
            if (this.props.fallback) {
                return this.props.fallback;
            }

            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '200px',
                    padding: '2rem',
                    textAlign: 'center',
                    backgroundColor: '#FEF2F2',
                    borderRadius: '12px',
                    border: '1px solid #FECACA',
                    margin: '1rem',
                }}>
                    <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>⚠️</div>
                    <h3 style={{ 
                        color: '#991B1B', 
                        marginBottom: '0.5rem',
                        fontSize: '1.1rem',
                        fontWeight: 600 
                    }}>
                        Algo deu errado
                    </h3>
                    <p style={{ 
                        color: '#7F1D1D', 
                        marginBottom: '1rem',
                        fontSize: '0.9rem',
                        maxWidth: '400px' 
                    }}>
                        {this.props.message || 'Ocorreu um erro inesperado ao carregar este componente.'}
                    </p>
                    <button
                        onClick={this.handleRetry}
                        style={{
                            padding: '0.5rem 1.5rem',
                            backgroundColor: '#DC2626',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '0.9rem',
                            fontWeight: 500,
                            transition: 'background-color 0.2s',
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#B91C1C'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#DC2626'}
                    >
                        Tentar novamente
                    </button>
                    {import.meta.env.DEV && this.state.error && (
                        <details style={{ 
                            marginTop: '1rem', 
                            textAlign: 'left',
                            width: '100%',
                            maxWidth: '600px'
                        }}>
                            <summary style={{ cursor: 'pointer', color: '#991B1B' }}>
                                Detalhes do erro (dev)
                            </summary>
                            <pre style={{ 
                                fontSize: '0.75rem', 
                                overflow: 'auto',
                                backgroundColor: '#FFF',
                                padding: '0.5rem',
                                borderRadius: '4px',
                                marginTop: '0.5rem'
                            }}>
                                {this.state.error.toString()}
                                {this.state.errorInfo?.componentStack}
                            </pre>
                        </details>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
